import axios, { AxiosRequestConfig } from 'axios'

import {
  iExtractVerbsConfig,
  iPath,
  iRequestMethodOverload,
  iVerbObj,
} from './types'
import { composeUrl } from './utils'

export type iExtractVerbs = (params: iExtractVerbsConfig) => iVerbObj

const extractVerbs: iExtractVerbs = ({
  pathName,
  verbs,
  pathConfig,
  generalConfig,
}) => {
  const verbObj = {} as iVerbObj

  const entries: [string, iPath][] = Object.entries(verbs)

  entries.forEach(([verbName, verbData]) => {
    const mergeConfig = {
      url: pathName,
      method: verbName,
      ...generalConfig,
      ...pathConfig,
      ...verbData,
    }

    const requestConfig = {
      baseURL: composeUrl({
        protocol: mergeConfig.protocol,
        host: mergeConfig.host,
        basepath: mergeConfig.basepath,
      }),
      ...mergeConfig,
    }

    const requestMethod: iRequestMethodOverload = async (
      sendData,
      requestData,
    ) => {
      const toParam = ['get', 'head', 'options', 'purge']
      const toData = [
        'delete',
        'post',
        'put',
        'patch',
        'link',
        'unlink',
      ]

      const hasBody = toData.includes(verbName.toLowerCase())
      const hasQueryParam = toParam.includes(verbName.toLowerCase())

      const data =
        requestData?.data || (hasBody && sendData) || undefined

      const params =
        requestData?.params ||
        (hasQueryParam && sendData) ||
        undefined

      const urlParams =
        requestData?.urlParams !== undefined
          ? {
              url: `${requestConfig.url}/${requestData.urlParams.join(
                '/',
              )}`,
            }
          : undefined

      const mergeConfig: AxiosRequestConfig = {
        ...requestConfig,
        ...urlParams,
        ...(data !== undefined ? { data } : data),
        ...(params !== undefined ? { params } : params),
        ...requestData?.config,
      }

      return await axios.request(mergeConfig)
    }

    requestMethod.requestConfig = requestConfig

    verbObj[verbName] = requestMethod
  })

  return verbObj
}

export { extractVerbs }
